export async function createWeeklyMinutes(gymStateDb: any, logger: any) {
  logger.info('create total minutes view index');

  const ddoc = {
    _id: '_design/total-minutes-per-workout',
    views: {
      'total-minutes-per-workout': {
        map: `function (doc) {
          if (!doc.userProfileId || doc.removedAt) {
            return;
          }

          var startTimeOfFirstExerciseInMs = new Date(doc.startTimeOfFirstExercise).getTime();
          var endTimeOfWorkoutInMs = new Date(doc.endTime).getTime();
          var additionalSecondsBeforeFirstExerciseInMs = ((doc.additionalSecondsBeforeFirstExercise || 0) * 1000);

          var totalMinutes = Math.round(
            (endTimeOfWorkoutInMs - startTimeOfFirstExerciseInMs - additionalSecondsBeforeFirstExerciseInMs) / 60000
          );
          var load = doc.performanceMetrics && doc.performanceMetrics.load ? doc.performanceMetrics.load : 0;
          emit([doc.userProfileId, startTimeOfFirstExerciseInMs, endTimeOfWorkoutInMs, doc.workoutType, load],
           totalMinutes);
        }`,
      },
    },
  };

  await gymStateDb.put(ddoc);
}
